import React from "react";
import { Adsense } from "@ctrl/react-adsense";
import { useLocation } from "../../context/LocationContext";

/* ==========================
   ✅ DEVICE DETECTION (FIXED)
   ========================== */
const getDeviceType = () => {
  const ua = navigator.userAgent;

  if (/iPad|Tablet/i.test(ua)) return "tablet";
  if (/iPhone|Android.+Mobile/i.test(ua)) return "mobile";
  return "desktop";
};

function AdCard({ ad }) {
  const { location } = useLocation();

  if (!ad) return null;

  const isAdsense = ad.client && ad.slot;

  /* ==========================
     ✅ TRACK CLICK FUNCTION
     ========================== */
  const trackClick = async (adData) => {
    try {
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/track-ad-click`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          zipcode: location?.zipcode || null,
          country: location?.country || null,
          deviceType: getDeviceType(),
          adId: ad.id || ad.slot || "unknown",
          timestamp: new Date().toISOString(),
          ...adData,
        }),
      });
    } catch (error) {
      console.error("Failed to track ad click:", error);
    }
  };

  /* ==========================
     ✅ ADSENSE BLOCK
     ========================== */
  if (isAdsense) {
    return (
      <div
        className="card"
        style={{
          padding: "12px",
          minHeight: "250px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Adsense
          client={ad.client || "ca-pub-6409212221098617"}
          slot={ad.slot || "3259974102"}
          style={{
            display: "block",
            width: "100%",
            maxWidth: "300px",
            height: "300px",
          }}
          format="auto"
          responsive="true"
        />

        <div
          style={{
            fontSize: "10px",
            color: "#999",
            marginTop: "8px",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          Advertisement
        </div>
      </div>
    );
  }

  /* ==========================
     ✅ IMAGE AD (IPHONE FIXED)
     ========================== */
  const { image, link } = ad;

  return (
    <a
      href={link || "#"}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackClick({ type: "image", link })}
      style={{ textDecoration: "none" }}
    >
      <div
        className="card"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "12px",
          minHeight: "250px",
          cursor: link ? "pointer" : "default",
          borderRadius: "12px",
        }}
      >
        <img
          src={image}
          alt="Advertisement"
          style={{
            maxWidth: "100%",
            height: "auto",
            objectFit: "contain",
          }}
        />

        <div
          style={{
            paddingTop: "15px",
            fontSize: "10px",
            color: "#999",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          Advertisement
        </div>
      </div>
    </a>
  );
}

export default AdCard;
